import axios from "axios";

export const JoinWaitlist = async (phoneNumber) => {
  if (!phoneNumber) return;

  try {
    const data = {
      phone: phoneNumber,
    };

    const response = await axios.post(
      "https://flit-core-backend-production.up.railway.app/api/waitlist/join-waitlist",
      data
    );
    console.log(response.data);
    return response.data;
  } catch (error) {
    if (error.response) {
      const { status } = error.response;
      // console.log(status);

      if (status === 400) {
        return "Already Exist";
      } else return null;
    }
    return null;
  }
};
